import React from 'react';
import PropTypes from 'prop-types';

export default function MenuIcon({ size, color, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 19 19" {...rest}>
      <path
        fill={color}
        id="a"
        d="M0 .76C0 .34.334 0 .746 0h9.704c.412 0 .746.34.746.76s-.334.76-.746.76H.746A.753.753 0 0 1 0 .76zM0 7.6c0-.42.334-.76.746-.76h19.408c.412 0 .746.34.746.76s-.334.76-.746.76H.746A.753.753 0 0 1 0 7.6zm.746 6.08a.753.753 0 0 0-.746.76c0 .42.334.76.746.76h19.408c.412 0 .746-.34.746-.76s-.334-.76-.746-.76H.746z"
      />
    </svg>
  );
}

MenuIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

MenuIcon.defaultProps = {
  size: 19,
  color: '#FFF',
};
